import { render, staticRenderFns } from "./CaseConfigHeader.vue?vue&type=template&id=b8c2c730"
import script from "./CaseConfigHeader.vue?vue&type=script&lang=js"
export * from "./CaseConfigHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports